// @ts-nocheck
import {
    APP_VERSIONS_RECEIVED,
    APPLICATION_TYPE_CHANGED,
    EVENT_STATUSES_RECEIVED,
    EVENT_TYPES_RECEIVED,
    MBN_TYPES_RECEIVED,
    UNSAVED_CHANGES,
    UPDATE_VERSION_RECEIVED,
} from '../types';
import GeneralService from '../../services/GeneralService';
import { notification } from 'antd';

export const updateUnsavedChanges = hasChanges => ({
    type: UNSAVED_CHANGES,
    payload: hasChanges,
});

export const getEventTypes = () => async dispatch => {
    const data = await GeneralService.getEventTypes();

    if (data?.items) {
        dispatch(setEventTypes(data.items));
    }
};

export const setEventTypes = payload => ({
    type: EVENT_TYPES_RECEIVED,
    payload,
});

export const getEventStatuses = () => async dispatch => {
    const data = await GeneralService.getEventStatuses();

    if (data?.item) {
        dispatch(setEventStatuses(data.item));
    }
};
export const setEventStatuses = payload => ({
    type: EVENT_STATUSES_RECEIVED,
    payload,
});
export const getMbnTypes = () => async dispatch => {
    const data = await GeneralService.getMbnTypes();

    if (data?.items) {
        dispatch(setMbnTypes(data.items));
    }
};

export const setMbnTypes = payload => ({
    type: MBN_TYPES_RECEIVED,
    payload,
});

export const setAppVersions = payload => ({
    type: APP_VERSIONS_RECEIVED,
    payload,
});

export const getAppVersions = () => async dispatch => {
    const data = await GeneralService.getAppVersions();

    if (data?.items) {
        dispatch(setAppVersions(data.items));
    }
};

export const createAppVersion =
    ({ data }) =>
    async () => {
        const { info } = await GeneralService.createAppVersion(data);

        return info;
    };

export const changeApplicationTypeChanged = filters => ({
    type: APPLICATION_TYPE_CHANGED,
    payload: filters,
});
